// extracted by mini-css-extract-plugin
export default {"title":"titleSection_title__wG+xb"};